/**
 * Normalize a draft multi-select to the persisted/API convention:
 * empty array = "all orgs in scope".
 * Selecting every option is stored as [] so consumers that expand empty → all
 * stay consistent.
 */
export function normalizeOrgSelection(draft: number[], optionCount: number): number[] {
    if (optionCount > 0 && draft.length === optionCount) {
        return [];
    }
    return draft;
}

/**
 * Expand an empty (all) selection to every option id for checkbox UI seeding.
 */
export function expandOrgSelectionForDraft(
    selectedOrgIds: number[],
    optionOrgIds: number[],
): number[] {
    if (selectedOrgIds.length === 0 && optionOrgIds.length > 0) {
        return [...optionOrgIds];
    }
    return [...selectedOrgIds];
}
